import { Form, Input, ModalProps, FormProps, Modal, Select, InputNumber, useSelect, Col, Row } from '@pankod/refine-antd'
import { useCreateMany, useDeleteMany, useGetIdentity, useOne } from '@pankod/refine-core'
import { useEffect, useMemo, useState } from 'react'
import { DatePicker } from 'antd'
import type { RangePickerProps } from 'antd/es/date-picker'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { IEvaluationEvaluators, ITestEvent } from 'interfaces'
import { useUserContext } from 'context/user'
import testEventMetaData from 'metadata/test_events'
import { findAlreadyAssignPaperForTestEvent } from 'gql/query'
// var utc = require("dayjs/plugin/utc")
type CreateThemeProps = {
  modalProps: ModalProps
  formProps: FormProps
  request: any
  data: any
}
dayjs.extend(utc)

export const EditEvaluationRequest: React.FC<CreateThemeProps> = ({ modalProps, formProps, request, data }) => {
  const [allPapers, setAllPapers] = useState<any>([])
  const { data: user } = useGetIdentity()
  const { evaluationInCharge, evaluators } = useUserContext()

  const [selectedEvaluators, setSelectedEvaluators] = useState([] as any[])
  const { mutate } = useDeleteMany<IEvaluationEvaluators>()
  const { mutate: createEvaluators } = useCreateMany<IEvaluationEvaluators>()

  const { data: testEventQueryResponse } = useOne<ITestEvent>({
    id: request,
    resource: 'test_events',
    metaData: testEventMetaData,
    queryOptions: { enabled: !!!request?.id && modalProps?.visible },
  })
  const testEvent = testEventQueryResponse?.data

  const validTestEvent = useMemo(() => (!!request?.id ? request : testEvent), [request, testEvent])

  const findAlreadyAssignedPaper = async () => {
    if (request?.id) {
      //finding already assigned paper to the test event
      const assignedPapersResposne: any = await findAlreadyAssignPaperForTestEvent(request.id)
      //assigned papers
      const assignedPapers =
        assignedPapersResposne?.test_event_assigned_papers?.map((item: any) => ({
          ...item?.paper,
          assignedPaper: true,
        })) || []
      //available papers
      const availablePapers = request?.papers || []
      //combining both arrays
      setAllPapers([...(assignedPapers || []), ...(availablePapers || [])])
    }
  }

  useEffect(() => {
    let arr: object[] = []
    if (data?.evaluators?.length > 0) {
      data?.evaluators?.forEach((elem: any) => {
        if (!arr?.includes(elem?.id)) arr?.push(elem?.id)
      })
    }

    if (request?.id) {
      findAlreadyAssignedPaper()
    }
    setSelectedEvaluators(arr)
  }, [data, request])
  console.log('first', request, data)
  const disabledDate: RangePickerProps['disabledDate'] = current => {
    // Can not select days before today and today
    return current && current < dayjs().add(-1, 'day')
  }

  const onFinish = async (values: any) => {
    return (
      formProps.onFinish &&
      formProps.onFinish({
        ...values,
        test_event_id: validTestEvent?.id,
      })
    )
  }

  return (
    <Modal {...modalProps} title="Edit Evaluation Slot">
      <Form
        {...formProps}
        size="large"
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            // console.log('xxxxxxxxxxxxxx', response)
            if (response) {
              let array: object[] = []

              if (data?.evaluator_ids?.length > 0)
                mutate({
                  resource: 'evaluation_evaluators',
                  ids: selectedEvaluators,
                })
              if (values?.evaluator_ids?.length > 0) {
                values?.evaluator_ids?.forEach((element: any) => {
                  array?.push({
                    evaluator_id: element,
                    evaluation_request_id: response?.data?.id,
                  })
                })
                createEvaluators({
                  resource: 'evaluation_evaluators',
                  values: array,
                })
              }
            }
          })

          return response
        }}
      >
        {/* <Row>
          
       </Row> */}
        <Row gutter={[16, 0]}>
          <Col lg={12}>
            <Form.Item
              label="Slot"
              name="slot_selected"
              rules={[{ required: true }]}
              getValueProps={value => ({
                value: value ? dayjs(value) : '',
              })}
            >
              <DatePicker
                disabled={data?.status !== 'Open'}
                format="YYYY-MM-DD HH:mm:ss"
                showTime={{
                  defaultValue: data?.slot_selected,
                }}
                style={{ width: '100%' }}
                disabledDate={disabledDate}
              />
            </Form.Item>
          </Col>
          <Col lg={12}>
            <Form.Item label="Paper" name="paper_id" rules={[{ required: true }]}>
              <Select disabled={data?.status !== 'Open'}>
                {allPapers?.length > 0 &&
                  allPapers?.map((item: any) =>
                    item?.status === 'Approved' ? (
                      <option key={item?.id} value={item?.id}>
                        {`#${item?.paper_id}-${item?.paper_smart_id} ${item.assignedPaper ? '(Assigned Existing Paper)' : ''}`}
                      </option>
                    ) : null
                  )}
              </Select>
              {/* <DatePicker format="YYYY-MM-DD HH:mm:ss" disabledDate={disabledDate} /> */}
            </Form.Item>
          </Col>
          <Col lg={24}>
            <Form.Item label="Evaluation In Charge" name="evaluation_in_charge" rules={[{ required: true }]}>
              <Select disabled={data?.status !== 'Open'}>
                {evaluationInCharge.length > 0 &&
                  evaluationInCharge?.map(item => (
                    <option key={item?.id} value={item?.id}>
                      {item?.displayName}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          {/* <Col lg={24}>
            <Form.Item label="Evaluators" name="evaluator_ids" rules={[{ required: true }]}>
              <Select mode="multiple" disabled={data?.status !== 'Open'}>
                {evaluators.length > 0 &&
                  evaluators?.map(item => (
                    <option key={item?.id} value={item?.id}>
                      {item?.displayName}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col> */}
        </Row>

        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}